import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,

  OutlinedInput,
  InputAdornment,

} from '@mui/material';
import {  useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: "0px" //theme.spacing(0, 0, 0, 0)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

export default function UserSearch({ filterName, onFilterName}) {
  const {t} = useTranslation();
  return (
    <RootStyle className="searchContainer">

        <SearchStyle
     
            value={filterName}
            onChange={onFilterName}
            placeholder={t("usermgmt_placeholder_user_search")}
            startAdornment={
            <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
            }
        />

    </RootStyle>
  );
}
